import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: 'include' };

// Ödeme geçmişi (sayfalı)
export const fetchPaymentHistory = async (params) => {
    const res = await fetch(`${API.payments_history}?${new URLSearchParams(params)}`, {
        ...fetchOpts,
    });
    return res.json();
};

// Tek ödemenin detayı (liste DTO'su ile aynı şekil)
export const fetchPaymentById = async (paymentId) => {
    const res = await fetch(API.payment_detail_by_id(paymentId), { ...fetchOpts });
    return res.json();
};

// Ödeme anında onaylanan sözleşme (metin + hash + onay IP'si).
// Ayrı uçta: metin kilobaytlarca olabildiği için detay yanıtında taşınmaz.
export const fetchPaymentContract = async (paymentId) => {
    const res = await fetch(API.payment_contract(paymentId), { ...fetchOpts });
    return res.json();
};

// İade geçmişi (sayfalı, filtreli). Yetki kapsamı backend'de zorlanır:
// SUPER_ADMIN dışındaki roller için companyId gönderilse de kendi firmasına bağlanır.
export const fetchRefundHistory = async (params) => {
    const res = await fetch(`${API.payment_refunds}?${new URLSearchParams(params)}`, {
        ...fetchOpts,
    });
    return res.json();
};

// Tek ödemenin detayı + tüm iade geçmişi (İşlem Detayı panelindeki İade bölümü)
export const fetchPaymentRefundDetail = async (paymentId) => {
    const res = await fetch(API.payment_refund_detail(paymentId), { ...fetchOpts });
    return res.json();
};

// Ödeme silme
export const deletePayments = async (paymentIds) => {
    const res = await fetch(API.payments_history, {
        method: 'DELETE',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ ids: paymentIds }),
    });
    return res.json();
};

// Muhasebeleşme durumu güncelle
export const updatePaymentAccounted = async (paymentId, accounted) => {
    const res = await fetch(`${API.payment_accounted(paymentId)}?accounted=${accounted}`, {
        method: 'PATCH',
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Muhasebe durumu güncellenemedi");
    return res.json();
};

// PayTR tutar iadesi (tam/kısmi). amount null/undefined ise kalan tutarın tamamı iade edilir.
// idempotencyKey: çift gönderim engeli (aynı key ile ikinci istek 409 döner, PayTR'ye gitmez).
export const refundPayment = async (paymentId, amount, idempotencyKey) => {
    const payload = {};
    if (amount != null) payload.amount = amount;
    if (idempotencyKey) payload.idempotencyKey = idempotencyKey;
    const res = await fetch(API.payment_refund(paymentId), {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.message || "İade işlemi başarısız oldu");
    return json;
};

// Sağlayıcıya özel iade ucuna POST atan ortak yardımcı (tam/kısmi; amount null → kalanın tamamı).
const postRefund = async (url, amount, idempotencyKey) => {
    const payload = {};
    if (amount != null) payload.amount = amount;
    if (idempotencyKey) payload.idempotencyKey = idempotencyKey;
    const res = await fetch(url, {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.message || "İade işlemi başarısız oldu");
    return json;
};

// Garanti BBVA tutar iadesi (tam/kısmi).
export const refundGarantiPayment = (paymentId, amount, idempotencyKey) =>
    postRefund(API.payment_refund_garanti(paymentId), amount, idempotencyKey);

// İşyerimPOS tutar iadesi / iptali (tam/kısmi). Aynı gün + tam tutar iptali (VOID),
// diğer durumlar iade (REFUND) olarak backend'de otomatik seçilir.
export const refundIsyerimPosPayment = (paymentId, amount, idempotencyKey) =>
    postRefund(API.payment_refund_isyerimpos(paymentId), amount, idempotencyKey);

// İade edilebilir sağlayıcı → iade fonksiyonu. Backend'de iade ucu OLAN sağlayıcılar:
// PAYTR, GARANTI, ISYERIM_POS. (ParamPOS/EsnekPos/iyzico'da iade ucu yoktur.)
const REFUND_HANDLERS = {
    PAYTR: (p, amount, key) => refundPayment(p.id, amount, key),
    GARANTI: (p, amount, key) => refundGarantiPayment(p.id, amount, key),
    ISYERIM_POS: (p, amount, key) => refundIsyerimPosPayment(p.id, amount, key),
};

// Ödemenin geçtiği sanal POS sağlayıcısına göre DOĞRU iade ucunu seçer.
export const refundPaymentAuto = async (payment, amount, idempotencyKey) => {
    const handler = REFUND_HANDLERS[payment?.virtualPos];
    if (!handler) {
        throw new Error("Bu ödeme sağlayıcısı için iade desteklenmiyor.");
    }
    return handler(payment, amount, idempotencyKey);
};

// Makbuzu e-posta ile gönder. email boş bırakılırsa ödemeyi yapanın adresine gider.
export const sendPaymentReceiptEmail = async (paymentId, email) => {
    const res = await fetch(API.payment_receipt_email(paymentId), {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(email ? { email } : {}),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.message || "Makbuz gönderilemedi");
    return json;
};

// Toplu muhasebeleşme durumu güncelle
export const bulkUpdateAccounted = async (ids, accounted) => {
    const res = await fetch(API.payment_bulk_accounted, {
        method: 'PATCH',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ ids, accounted }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Toplu güncelleme başarısız");
    return res.json();
};

// Ödeme geçmişi Excel indirme
export const downloadPaymentHistoryExcel = async (params) => {
    const res = await fetch(`${API.payments_history}?${new URLSearchParams(params)}`, { ...fetchOpts });
    if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.message || "Excel indirilemedi");
    }
    return res.blob();
};

// Ödeme işle (3DS dahil).
// idempotencyKey: çift gönderim engeli. Backend anahtarı sağlayıcıya GİTMEDEN önce
// sahiplenir; aynı anahtarla gelen ikinci istek yeni bir kart işlemi başlatmaz
// (409), farklı bir ödeme için kullanılmışsa 422 döner. Başlık gönderilmezse
// koruma hiç devreye girmez, bu yüzden anahtar üretimi çağıranın sorumluluğunda.
export const processPayment = async (body, idempotencyKey) => {
    const headers = getHeaders();
    if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
    const res = await fetch(API.process_payment, {
        method: 'POST',
        ...fetchOpts,
        headers,
        body: JSON.stringify(body),
    });
    return res;
};

// Anlık ödeme linki oluştur
export const createInstantLink = async (dto) => {
    const res = await fetch(API.create_instant_link, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(dto),
    });
    return res;
};

// Anlık ödeme link bilgisi getir
export const fetchInstantLinkInfo = async (linkId) => {
    const res = await fetch(`${API.instant_link_info}/${linkId}`, {
        headers: getHeaders(),
    });
    return res;
};

// Link tıklanma işaretle
export const markLinkClicked = async (linkId) => {
    const res = await fetch(API.markLinkClicked(linkId), { method: 'POST' });
    return res;
};

// Sabit link durumunu değiştir (ACTIVE | PAUSED)
export const updatePaymentLinkStatus = async (linkId, status) => {
    const res = await fetch(API.payment_link_status(linkId, status), {
        method: 'PATCH',
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};

// Sabit link adresini (token) yenile — eski URL geçersiz olur
export const rotatePaymentLinkToken = async (linkId) => {
    const res = await fetch(API.payment_link_rotate_token(linkId), {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};

// Ödeme bağlantısını sil — yumuşak silme; ödeme geçmişi korunur, link ödemeye kapanır
export const deletePaymentLink = async (linkId) => {
    const res = await fetch(API.payment_link_delete(linkId), {
        method: 'DELETE',
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};

// Ödeme fallback kontrol
export const checkPaymentFallback = async (merchantOid) => {
    const res = await fetch(API.check_payment_fallback(merchantOid));
    return res;
};

// Ödeme fallback işaretle
export const markPaymentFallback = async (merchantOid) => {
    const res = await fetch(API.mark_payment_fallback(merchantOid), { method: 'POST' });
    return res;
};

// Taksit grupları (benim)
export const fetchInstallmentGroups = async () => {
    const res = await fetch(API.installments, {
        ...fetchOpts,
        headers: getHeaders(),
    });
    return res;
};

// BIN detay (auth gerekli)
export const fetchBinDetail = async (bin, companyId, signal) => {
    const res = await fetch(API.bin_detail(bin, companyId), {
        ...fetchOpts,
        headers: getHeaders(),
        ...(signal ? { signal } : {}),
    });
    return res;
};

// BIN sorgu (auth gerekmez)
export const queryBinNoAuth = async (bin, linkId) => {
    const res = await fetch(API.query_bin_no_auth(bin, linkId), {
        headers: getHeaders(),
    });
    return res;
};

// Final kur oranları
export const fetchFinalRates = async (companyId) => {
    const opts = companyId
        ? { ...fetchOpts, headers: getHeaders() }
        : {};
    const res = await fetch(`${API.final_rates}?companyId=${companyId}`, opts);
    return res;
};

// Firma sözleşmesi getir
export const fetchCompanyContract = async (payload) => {
    const res = await fetch(API.get_company_contract, {
        method: 'POST',
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    return res;
};
